module.exports = require("cloudinary-core");


//////////////////
// WEBPACK FOOTER
// external "cloudinary-core"
// module id = 44
// module chunks = 0